import { type FC } from 'react';

import { MapBoundsUpdateManager } from './internal/components/MapBoundsUpdateManager';
import { MapSizeUpdateManager } from './internal/components/MapSizeUpdateManager';

export const MapManagers: FC = () => {
  return (
    <>
      <MapBoundsUpdateManager />
      <MapSizeUpdateManager />
    </>
  );
};
